module.exports = __webpack_public_path__ + "img/picturePlus.0b47ded.png";